import { render } from "./Workflows.vue?vue&type=template&id=4513c663&scoped=true&lang=pug"
import script from "./Workflows.js?vue&type=script&lang=js&external"
export * from "./Workflows.js?vue&type=script&lang=js&external"

import "./Workflows.vue?vue&type=style&index=0&id=4513c663&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4513c663"]])

export default __exports__